import { ArchivedNewBusinessModule, PageHeader } from '@korint/folio';

export function ArchivedNewBusiness() {
  return (
    <div>
      <PageHeader title="Devis archivés" />
      <ArchivedNewBusinessModule />
    </div>
  );
}
